// extracted by mini-css-extract-plugin
export default {"headingH2":"training_headingH2__qFWQ0","breadcrumbs":"training_breadcrumbs__41Ovb","aboutp":"training_aboutp__KqCCC","aboutH3":"training_aboutH3__0Jckr"};